import { Injectable } from '@angular/core';
import { IID_RISORSA_LORA } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDRisorsaLORAStore } from './iidRisorsaLORA.store';
import { IIDRisorsaLORAQuery } from './iidRisorsaLORA.query';
import { WsACKCallback } from '@common/api/ack';
import { InsertPrjActivitiesResponse, SelectGatewayLoraDTO, SelectGatewayLoraResponse } from '@common/interfaces/gisfo';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.RISORSA_LORA)
export class IIDRisorsaLORAService extends CrudService<IID_RISORSA_LORA, IIDRisorsaLORAStore, IIDRisorsaLORAQuery> {
  constructor(
    protected store: IIDRisorsaLORAStore,
    public query: IIDRisorsaLORAQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService,
  ) {
    super(Topics.IID_RISORSA_LORA, store, query, actionService, updateStrategy);
  }

  getLoraInfo(dto: SelectGatewayLoraDTO, callback?: WsACKCallback<SelectGatewayLoraResponse>) {
    this.featureCommandService.send<SelectGatewayLoraResponse>(
      {
        target: 'feature:risorsa-lora',
        command: 'get-lora-from-gisfo',
        dto,
      },
      () => this.actionService.sendMessage(Topics.IID_RISORSA_LORA, 'getLoraFromGisfo', dto, callback),
      callback,
    );
  }

  refresh(fkEntity: string, id?: string, callback?: WsACKCallback<SelectGatewayLoraResponse>) {
    const dto = { id, fkEntity };
    this.featureCommandService.send<SelectGatewayLoraResponse>(
      {
        target: 'feature:risorsa-lora',
        command: 'refresh',
        dto,
        ...this.projectIdFromEntity(id),
      },
      () => this.actionService.sendMessage(Topics.IID_RISORSA_LORA, 'refresh', dto, callback),
      callback,
    );
  }

  clear(id: string, callback?: WsACKCallback<SelectGatewayLoraResponse>) {
    const dto = { id };
    this.featureCommandService.send<SelectGatewayLoraResponse>(
      {
        target: 'feature:risorsa-lora',
        command: 'clear',
        dto,
        ...this.projectIdFromEntity(id),
      },
      () => this.actionService.sendMessage(Topics.IID_RISORSA_LORA, 'clear', dto, callback),
      callback,
    );
  }

  createFault(id: string, activityType: number, callback?: WsACKCallback<InsertPrjActivitiesResponse>) {
    const dto = { id, activityType };
    this.featureCommandService.send<InsertPrjActivitiesResponse>(
      {
        target: 'feature:risorsa-lora',
        command: 'create-fault',
        dto,
        ...this.projectIdFromEntity(id),
      },
      () => this.actionService.sendMessage(Topics.IID_RISORSA_LORA, 'createFault', dto, callback),
      callback,
    );
  }

  private projectIdFromEntity(id?: string): { projectId?: string } {
    const projectId = id ? this.query.getEntity(id)?.projectId : null;
    return projectId ? { projectId } : {};
  }
}
